import React from 'react';
import { generateBemCss } from 'general/js/helpers';
import { getTotalBemClass } from './score-themes';

const ScoreTotalCell = ({ par, childCss }) => {
    const bemCss = generateBemCss('score-cell', [getTotalBemClass(par), 'has-border']);
    let parText = par;
    var textScoreClass = '';

    if (isNaN(parText) && (parText.length > 1)) {
        textScoreClass = 'score-is-text';        
    }

    if (!parText) {
        parText = '-';
    }

    return <div className={`${childCss} ${bemCss} ${textScoreClass}`}>{parText}</div>;
};

ScoreTotalCell.defaultProps = {
    childCss: '',
};

export default ScoreTotalCell;
